module.exports = __webpack_public_path__ + "static/media/fwdfwd-light.42004a78.svg";